module.exports = __webpack_public_path__ + "static/img/公众号二维码.3408dfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/公众号二维码.png?v=1.1
// module id = 9FpC
// module chunks = 12